module.exports = __webpack_public_path__ + "static/media/28.80f8dab4.jpg";